import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d093223"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Actions", -1))

import Column from "primevue/column";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import { ref, onMounted } from "vue";
import { productService } from "@/_services/product/product";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { IMasterProduct } from "@/models/product/IMasterProduct";
import router from "@/router";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'HiddenMasterProductByCompanyList',
  setup(__props) {

const page = ref<number>(1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const masterProducts = Array<IMasterProduct>();
const tableData = ref<Array<IMasterProduct>>(masterProducts);
const currentPage = ref<number>(1);
const criteria = ref<string>("");                                                                                                                                    
const totalRecords = ref<number>(0);

onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value);
});

const populateDatatable = async (itemsPerPage: number, page: number, criteria: string) => {
    showSpinner();

    const companyUuid = router.currentRoute.value.params.uuid;
    if (!companyUuid) {
        swal.error("Aucun identifiant de société trouvé dans l'URL.");
        return;
    }

    const [loadingDt, totalRecordsDt, tableDataDt] = await productService.fetchProductRestrictionsByCompany(
        companyUuid,
        itemsPerPage,
        page,
        criteria
    );
    totalRecords.value = totalRecordsDt;
    isLoading.value = loadingDt;
    tableData.value = tableDataDt;
};


const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page + 1;
    page.value = e.page + 1;
    populateDatatable(rows.value, currentPage.value , criteria.value);
};

const onFilterDt = async () => {
    if (criteria.value != "") {
        await populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = async () => {
    if (criteria.value === "") {
        await populateDatatable(rows.value, page.value, "");
    }
};

const deleteProductRestriction = async (companyUuid: string, masterProductUuid: string) => {
    swal
    .confirm("Êtes-vous sûr de vouloir supprimer la restriction de visibilité du produit ?")
    .then((result) => {
        if (result.isConfirmed) {
            ApiService.delete(`/admin/master-product-company/${companyUuid}/${masterProductUuid}`).then(() => {
                swal.success(
                    'Supprimé !',
                    'Vous venez de supprimer la restriction.'
                );
                populateDatatable(rows.value, page.value, criteria.value);
            });
        }
    });
}

const showSpinner = () => {
    isLoading.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("catalogue.productRestrictions.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DataTable), {
        first: (currentPage.value - 1) * rows.value,
        value: tableData.value,
        rows: rows.value,
        rowHover: true,
        paginator: true,
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        lazy: "",
        onPage: _cache[1] || (_cache[1] = ($event: any) => (onPaginate($event))),
        currentPage: currentPage.value,
        totalRecords: totalRecords.value
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createVNode(_unref(InputText), {
                modelValue: criteria.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputFilter,
                placeholder: "Rechercher un produit"
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _createVNode(_component_router_link, {
              class: "group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600",
              to: `/admin/companies/${_unref(router).currentRoute.value.params.uuid}/hidden-master-products/add`
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cacher un produit ")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Column), {
              field: "product_name",
              header: "Nom du produit"
            }),
            _createVNode(_unref(Column), {
              field: "brand",
              header: "Marque"
            }),
            _createVNode(_unref(Column), {
              field: "supplier_name",
              header: "Fournisseur"
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_7
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  onClick: () => deleteProductRestriction(slotProps.data.company_uuid, slotProps.data.master_product_uuid),
                  type: "button",
                  title: "Supprimer",
                  icon: "pi pi-trash",
                  class: "ml-1 p-button-danger"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["first", "value", "rows", "loading", "currentPage", "totalRecords"])
    ])
  ], 64))
}
}

})